export default "__VITE_ASSET__CP3qO3kv__"